"use client";

import { useRouter, useSearchParams } from "next/navigation";
import React, { useState } from "react";

function Sort() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const currentSort = searchParams?.get("sort") || "";

  const [optimisticSort, setOptimisticSort] = useState(currentSort);

  const sortOptions = [
    { value: "-hasPrice,-posted", label: "Posted Newest" },
    { value: "-hasPrice,posted", label: "Posted Oldest" },
    { value: "-hasPrice,price", label: "Price Lowest" },
    { value: "-hasPrice,-price", label: "Price Highest" },
  ];

  const handleSortChange = (value: string) => {
    setOptimisticSort(value);
    if (searchParams) {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      newSearchParams.set("sort", value);
      router.push(`?${newSearchParams.toString()}`);
    }
  };

  return (
    <div className="flex flex-col gap-y-6 py-6 lg:gap-y-3 lg:py-3">
      <div>
        <h3 className="font-semibold mb-2">Sort by</h3>
        <ul className="flex flex-col overflow-scroll max-h-[40vh] space-y-2 mb-4">
          {sortOptions.map((option) => (
            <li
              key={option.value}
              className="inline-flex flex-row items-center py-3 px-4 justify-between text-sm flex-grow flex-shrink-0 font-medium border-b border-gray-200 text-gray-800"
            >
              <button
                onClick={() => handleSortChange(option.value)}
                className="inline-flex gap-x-3.5 pr-3 font-bold w-full text-left focus:!bg-transparent active:!bg-transparent"
              >
                {option.label}
                <div className="flex-shrink-0 ml-auto">
                  <input
                    type="radio"
                    name="sort"
                    value={option.value}
                    checked={optimisticSort === option.value}
                    readOnly
                  />
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Sort;
